import "./generated-1784538152.css";

const A = "/generated/1784538152/assets";

const lessons = [
  ["1강: 함수의 극한", 100],
  ["2강 : 극한의 성질과 계산", 100],
  ["3강 : 극한의 성질과 계산", 100],
  ["4강 : 도함수의 활용", 74],
  ["5강 : 도함수의 그래프 활용", 0],
  ["6강 : 부정적분 기초", 0],
  ["7강 : 부정적분 기초", 0],
  ["8강 : 정적분과 넓이", 0],
] as const;

export default function Generated1784538152() {
  return (
    <main className="g8152-page">
      <aside className="g8152-sidebar">
        <div className="g8152-logo"><img src={`${A}/logo.png`} alt="내신인강" /></div>
        <button className="g8152-semester">2학년 1학기 중간<img src={`${A}/semester-chevron.png`} alt="" /></button>
        <nav className="g8152-nav">
          <img className="g8152-learning" src={`${A}/nav-learning.png`} alt="나의 학습" />
          {["과제", "직보자료", "질문", "선생님 공지", "알림", "마이페이지"].map((label) => (
            <button key={label}><span>{label}</span><b>2</b></button>
          ))}
        </nav>
      </aside>

      <section className="g8152-body">
        <div className="g8152-content">
          <header className="g8152-student-row">
            <div className="g8152-student">
              <img src={`${A}/avatar.png`} alt="" />
              <strong>이하은 학생</strong>
              <span>이화여자 강남 세화고등학교</span>
            </div>
            <button className="g8152-teacher">담당 : 한상우 선생님<img src={`${A}/teacher-chevron.png`} alt="" /></button>
          </header>

          <section className="g8152-rewards">
            <div className="g8152-streak">
              <img className="g8152-streak-bg" src={`${A}/streak-bg.png`} alt="" />
              <img className="g8152-medal" src={`${A}/streak-medal.png`} alt="" />
              <div className="g8152-streak-copy">
                <div><strong>연속 출석 3일 달성</strong><img src={`${A}/streak-marks.png`} alt="" /></div>
                <span>4일만 꾸준히 출석하면&nbsp; 위클리 엠블럼 획득가능</span>
              </div>
            </div>
            <div className="g8152-reward g8152-reward-one">
              <img className="g8152-reward-bg" src={`${A}/reward-bg-left.png`} alt="" />
              <img className="g8152-reward-art" src={`${A}/progress-reward.png`} alt="진도 보상 배지" />
              <div><strong>진도 보상</strong><span>3일 연속</span></div>
              <img className="g8152-reward-chevron" src={`${A}/reward-chevron-left.png`} alt="" />
            </div>
            <div className="g8152-reward g8152-reward-two">
              <img className="g8152-reward-bg" src={`${A}/reward-bg-right.png`} alt="" />
              <img className="g8152-reward-art" src={`${A}/assignment-reward.png`} alt="과제 보상 배지" />
              <div><strong>과제 보상</strong><span>3일 연속</span></div>
              <img className="g8152-reward-chevron" src={`${A}/reward-chevron-right.png`} alt="" />
            </div>
          </section>

          <section className="g8152-lower">
            <section className="g8152-exam">
              <h2>시험 정보</h2>
              <div className="g8152-exam-cols">
                <div><span>부교재</span><strong>쎈 수학Ⅰ + 자이스토리</strong></div>
                <div><span>시험 기간</span><strong>26.06.24 ~ 26.06.27</strong></div>
                <div><span>시험 범위</span><strong>함수의 극한과 연속 ~ 도함수의 활용 (접선의 방정식 또는 평균값 정리까지)</strong></div>
              </div>
            </section>

            <section className="g8152-progress-section">
              <h2>전체 학습 진도</h2>
              <div className="g8152-lessons">
                {lessons.map(([title, progress], index) => {
                  const state = progress === 74 ? "active" : progress === 0 ? "locked" : "done";
                  return <article className={`g8152-lesson ${state}`} key={title}>
                    <div className="g8152-lesson-main">
                      <div className="g8152-number"><img src={`${A}/lesson-${state}.png`} alt="" /><b>{index + 1}</b></div>
                      <div className="g8152-lesson-copy">
                        <strong>{title}</strong>
                        {progress > 0 && (progress === 74
                          ? <div className="g8152-progress active"><img src={`${A}/progress-active.png`} alt="진도 74%" /><span>74%</span></div>
                          : <div className="g8152-progress"><i /><span>100%</span></div>)}
                      </div>
                    </div>
                    {progress > 0 && <div className="g8152-status"><span>업로드 대기</span><b>{progress === 74 ? "시청 중" : "과제 제출 필요"}</b></div>}
                  </article>;
                })}
              </div>
            </section>
          </section>
        </div>
      </section>

      <button className="g8152-chat">
        <img className="g8152-chat-bg" src={`${A}/chat-bg.png`} alt="" />
        <span><img src={`${A}/chat-icon.png`} alt="" />채팅하기</span>
      </button>
    </main>
  );
}
